import type { ReactNode } from 'react';

interface OAuthButtonProps {
  logo: ReactNode;
  label: string;
  onClick: () => void;
  isDisabled?: boolean;
}

const stylesheet = {
  button:
    'flex items-center w-full h-14 px-2 rounded-semantic border border-semantic-border-2 bg-semantic-bg-input text-semantic-text-primary font-semibold transition-colors hover:bg-semantic-oauth-bg-hover disabled:opacity-50 disabled:cursor-not-allowed',
  logoChip:
    'h-10 w-10 rounded-semantic bg-semantic-surface-2 grid place-items-center shrink-0',
  label: 'flex-1 text-center pr-10 text-[15.5px]',
};

export function OAuthButton({
  logo,
  label,
  onClick,
  isDisabled = false,
}: Readonly<OAuthButtonProps>): ReactNode {
  return (
    <button
      type="button"
      className={stylesheet.button}
      onClick={onClick}
      disabled={isDisabled}
    >
      <span className={stylesheet.logoChip}>{logo}</span>
      <span className={stylesheet.label}>{label}</span>
    </button>
  );
}
